import localForage from 'localforage';
import { persistReducer } from 'redux-persist';
import { createSelector } from '@reduxjs/toolkit';
import { type RootState } from 'app/store';
import { type LogsState, type LogsActionTypes } from 'app/store/types';

const initialState: LogsState = {};

const logsReducer = (state = initialState, action: LogsActionTypes) => {
	switch (action.type) {
		case 'GET_LICENSE_GROUP_DATA_SUCCESS': {
			const {
				licenseGroupId,
				data: { logs },
			} = action.payload;

			return {
				...state,
				[licenseGroupId]: {
					...state[licenseGroupId],
					...(logs && { byId: logs }),
				},
			};
		}
		case 'LOGGED_OUT_USER':
		case 'PURGE_STATE':
			return initialState;
		default: {
			return state;
		}
	}
};

export default persistReducer(
	{
		key: 'logs',
		storage: localForage,
	},
	logsReducer,
);

// Selectors
export const getLogsById = ({ app: { selectedLicenseGroupId }, logs }: RootState) => logs[selectedLicenseGroupId].byId;

export const getLogs = createSelector([getLogsById], (logsById) => Object.values(logsById));
